import { LocaleLink } from "@i18n/routing";
import { Logo } from "@shared/components/Logo";
import { useTranslations } from "next-intl";

export function Footer() {
	const t = useTranslations();

	return (
		<footer className="border-t bg-gradient-to-br from-slate-50 to-gray-100/50">
			<div className="container mx-auto px-6 py-16">
				<div className="grid grid-cols-1 md:grid-cols-5 gap-8 lg:gap-12">
					{/* Brand Section - Takes 2 columns on desktop */}
					<div className="md:col-span-2 space-y-6">
						<LocaleLink href="/" className="inline-block">
							<Logo className="opacity-90 hover:opacity-100 transition-opacity duration-300" />
						</LocaleLink>
						<p className="text-base text-slate-600 leading-relaxed max-w-md pr-8">
							{t("common.footer.description")}
						</p>
					</div>

					{/* Tools Section */}
					<div className="space-y-6">
						<h3 className="font-semibold text-slate-900 text-lg">
							{t("common.menu.tools")}
						</h3>
						<div className="space-y-4">
							<LocaleLink
								href="/batch-image-to-prompt"
								className="block text-sm text-slate-600 hover:text-indigo-600 transition-colors duration-200 hover:translate-x-1 transform"
							>
								{t("batchImageToPrompt.title")}
							</LocaleLink>
							<LocaleLink
								href="/ai-describe-image"
								className="block text-sm text-slate-600 hover:text-indigo-600 transition-colors duration-200 hover:translate-x-1 transform"
							>
								{t("common.footer.aiDescribeImage")}
							</LocaleLink>
						</div>
					</div>

					{/* Quick Links Section */}
					<div className="space-y-6">
						<h3 className="font-semibold text-slate-900 text-lg">
							{t("common.footer.quickLinks")}
						</h3>
						<div className="space-y-4">
							<a
								href="https://1clickclaw.app/"
								target="_blank"
								rel="noopener noreferrer"
								className="block text-sm text-slate-600 hover:text-indigo-600 transition-colors duration-200 hover:translate-x-1 transform"
							>
								1ClickClaw
							</a>
							<a
								href="https://aistage.net"
								target="_blank"
								rel="noopener noreferrer"
								className="block text-sm text-slate-600 hover:text-indigo-600 transition-colors duration-200 hover:translate-x-1 transform"
							>
								AIStage
							</a>
							<a
								href="https://facelessvideos.app"
								target="_blank"
								rel="noopener noreferrer"
								className="block text-sm text-slate-600 hover:text-indigo-600 transition-colors duration-200 hover:translate-x-1 transform"
							>
								FacelessVideos APP
							</a>
							<a
								href="https://imagesart.ai/"
								target="_blank"
								rel="noopener noreferrer"
								className="block text-sm text-slate-600 hover:text-indigo-600 transition-colors duration-200 hover:translate-x-1 transform"
							>
								ImagesArt.ai
							</a>
							<a
								href="https://aifiguregenerator.co/"
								target="_blank"
								rel="noopener noreferrer"
								className="block text-sm text-slate-600 hover:text-indigo-600 transition-colors duration-200 hover:translate-x-1 transform"
							>
								AI Figure Generator
							</a>
							<a
								href="https://flux2klein.io"
								target="_blank"
								rel="noopener noreferrer"
								className="block text-sm text-slate-600 hover:text-indigo-600 transition-colors duration-200 hover:translate-x-1 transform"
							>
								Flux2Klein
							</a>
							<a
								href="https://ravvi.ai"
								target="_blank"
								rel="noopener"
								className="block text-sm text-slate-600 hover:text-indigo-600 transition-colors duration-200 hover:translate-x-1 transform"
							>
								Ravvi
							</a>
						</div>
					</div>

					{/* About Section */}
					<div className="space-y-6">
						<h3 className="font-semibold text-slate-900 text-lg">
							About
						</h3>
						<div className="space-y-4">
							<a
								href="mailto:support@imageprompt.co"
								className="block text-sm text-slate-600 hover:text-indigo-600 transition-colors duration-200 hover:translate-x-1 transform"
							>
								{t("common.footer.contactUs")}
							</a>
						</div>
					</div>
				</div>

				{/* Bottom Section */}
				<div className="mt-16 pt-8 border-t border-slate-200/70">
					<div className="flex flex-col sm:flex-row justify-between items-center gap-6">
						<div className="text-center sm:text-left">
							<p className="text-sm text-slate-500 font-medium">
								© {new Date().getFullYear()} ImagePrompt CO.{" "}
								{t("common.footer.allRightsReserved")}
							</p>
						</div>
						<div className="text-center sm:text-right">
							<div className="flex flex-wrap justify-center sm:justify-end gap-6">
								<LocaleLink
									href="/legal/privacy-policy"
									className="text-sm text-slate-500 hover:text-indigo-600 transition-colors duration-200 font-medium"
								>
									{t("common.footer.privacyPolicy")}
								</LocaleLink>
								<LocaleLink
									href="/legal/terms"
									className="text-sm text-slate-500 hover:text-indigo-600 transition-colors duration-200 font-medium"
								>
									{t("common.footer.terms")}
								</LocaleLink>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}
